<template>
  <div class="service">
    <ServiceCreateRoom v-if="mode=='create'"></ServiceCreateRoom>
  </div>
</template>

<script>

import ServiceCreateRoom from "@/components/Service/ServiceCreateRoom.vue";
import { mapActions } from "vuex";


export default {
  name: 'Login',
  components: {
    ServiceCreateRoom
  },
  data() {
    return {
      user: null,
      mode: 'create'
    }
  },
  async created() {
    try {
      let data = await this.currentUser();
      this.user = data.data.user;
    } catch (e) {
      await this.$router.push({
        name: 'login',
        query: { redirect: location.pathname + location.hash }
      })
    }
  },
  methods: {
    ...mapActions('auth', [
      'currentUser'
    ]),
  }
}
</script>

<style lang="scss" scoped>
.service {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
